<template>
  <DetailContainer class="customer-detail">
    <PageHeader
      slot="page-header"
      showBack
      showBreadcrumb
      @back="$router.push({ name: 'CustomerList' })"
    ></PageHeader>
    <div slot="top" class="customer-detail-top">
      <div class="basic">
        <hl-image
          :src="
            customerInfo.avatar
              ? createImgUrl(customerInfo.avatar)
              : require('@/assets/head_default.png')
          "
          width="64px"
          height="64px"
          class="image"
        ></hl-image>
        <span class="customerName"> {{ customerInfo.name | format }}</span>
        <div class="info-desc">
          <Descriptions :gutter="24">
            <DescriptionsItem labelWidth="auto" :label="$t('Customer.principal')">
              {{ customerInfo.manager | format }}
            </DescriptionsItem>
            <DescriptionsItem labelWidth="auto" :label="$t('Customer.phone')">
              {{ customerInfo.tel | format }}
            </DescriptionsItem>
            <DescriptionsItem labelWidth="auto" :label="$t('Customer.deviceManagedNum')">
              {{ customerInfo.count | format }}
            </DescriptionsItem>
          </Descriptions>
        </div>
      </div>
    </div>
    <!--    <Alert>-->
    <!--      当前展示的是已发布到线上的功能定义，如需修改，请点击-->
    <!--      <hl-button type="text" @click="toDraft">编辑草稿</hl-button>-->
    <!--    </Alert>-->
    <!--      :table-json="tablejson"-->
    <!--      :needPagination="false"-->
    <CustomerDetailTable ref="table" :tableData="tableData"> </CustomerDetailTable>
  </DetailContainer>
</template>

<script>
import DetailContainer from '@/components/DetailContainer/index'
import Descriptions from '@/components/Descriptions'
import DescriptionsItem from '@/components/Descriptions/DescriptionsItem'
import { format, formatTime, formatNumWithComma, createImgUrl } from '@/utils/utils'
import CustomerDetailTable from './CustomerDetailTable/index'
import Image from '@/components/CommonTable/Image'

export default {
  name: 'CustomerDetail',
  components: {
    'hl-image': Image,
    DetailContainer,
    Descriptions,
    DescriptionsItem,
    CustomerDetailTable
  },
  filters: {
    format,
    formatTime,
    formatNumWithComma
  },
  data() {
    return {
      customerInfo: {},
      customerId: this.$route.query.id,
      tableData: []
    }
  },
  created() {
    this.getProductDetail()
  },
  methods: {
    createImgUrl,
    getProductDetail() {
      const params = {
        id: this.customerId
      }
      return this.$ajax
        .get(this.$api.customer.customer_detail, params)
        .then((res) => {
          this.customerInfo = res.data
          this.tableData = res.data.deviceList
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-detail {
  .customer-detail-top {
    .customerName {
      margin-left: 16px;
      font-size: 24px;
      font-weight: 600;
      color: #333333;
      line-height: 24px;
    }
    .info-desc {
      margin-top: 38px;
    }
  }
}
</style>
